<script setup lang="ts">
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, reactive, defineProps, watch } from 'vue';
import getNoticesResponse from "@/types/responses/getNotices";
import notice from '@/types/notice'

const props = defineProps<{ isHamburgerOpen: boolean }>();

const noticeList: {
  data: notice[],
  unreadCount: number
} = reactive({
  data: [],
  unreadCount: 0,
})

onMounted(() => {
  getNoticeList()
})

const isOpen = ref()
const batchRemoved = ref(false)

watch(isOpen, () => {
  if (isOpen.value) {
    batchRemoved.value = true
    postWatched()
  }
})

const getNoticeList = () => {
  Api().getNotices().then((res: getNoticesResponse) => {
    noticeList.data = res.data
    noticeList.unreadCount = res.unread_count
  })
}

const postWatched = () => {
  if (noticeList.unreadCount == 0) return
  const watchedAt = noticeList.data[0].registered_at
  Api().upsertNoticeWatchedTime(watchedAt).then(() => {
    getNoticeList()
  })
}

const showAllNoticePage = () => {
  window.open(process.env.VUE_APP_SUPPORT_LINK, '_blank')
}

const showSpecifiedNoticePage = (url: string) => {
  window.open(url, '_blank')
}

</script>


<template>
  <v-menu v-model="isOpen" v-if="noticeList.data[0]">
    <template v-slot:activator="{props}">
      <div class="notice-icon">
        <span class="material-symbols-outlined " v-bind="props">
          notifications
        </span>
        <span
          class="badge bg-red notification-badge"
          v-if="noticeList.unreadCount > 0 && noticeList.unreadCount < 100 && !batchRemoved"
        >{{noticeList.unreadCount}}</span>
        <span
          class="badge bg-red notification-badge"
          v-if="noticeList.unreadCount >= 100 && !batchRemoved"
        >99+</span>
      </div>
    </template>
    <v-list class="notice-list">
      <v-list-item class="all-notice" @click="showAllNoticePage()">
        全てのお知らせ
      </v-list-item>
      <v-list-item class="notice-item" v-for="data in noticeList.data" v-bind:key="data.id" @click="showSpecifiedNoticePage(data.url)">
        <div class="notice-panel">
        <span class="notice-title">{{data.title}}</span>
        <span class="notice-date">{{data.date}}</span>
        </div>

      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
.badge {
    display: inline-block;
    color: #fff;
    padding: 0.2rem 0.3rem;
    border-radius: 1rem;
    font-size: 0.8rem;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
}

.bg-red {
    background-color: #E74C3C;
}
.notice-icon {
    position: relative;
}
.notice-icon > span {
  margin-top: 0.3em;
  font-size: 1.5em;
}
.notification-badge {
    position: absolute;
    left: 1rem;
    top: 0rem;
    font-size: xx-small !important;
}
.notice-list {
  max-height: 400px;
  background-color: gainsboro !important;
}
.notice-item {
  background-color: white;
  border-top: 1px solid;
}
.all-notice {
  color: royalblue;
  text-align: center;
}

.notice-panel {
  display: flex;
  flex-direction: column;
  max-width: 400px;
}

.notice-title {
  margin-bottom: 1em;
  overflow-wrap: break-word;
}
.notice-date {
  font-size: 10px;
}
</style>
